// 用户状态模块
export default {
  namespaced: true,

  state: {
    token: localStorage.getItem('admin_token') || localStorage.getItem('token') || '',
    userInfo: JSON.parse(localStorage.getItem('admin_user') || localStorage.getItem('userInfo') || '{}'),
  },

  getters: {
    // Report whether the current user already has a valid login token.
    isLoggedIn: state => !!state.token,
    // Render the top-right account name with the existing login name fallback chain.
    username: state => state.userInfo.login_name || state.userInfo.loginName || state.userInfo.username || state.userInfo.name || 'Admin',
    // Render the current account role name in the header.
    roleName: state => state.userInfo.group_name || state.userInfo.groupName || state.userInfo.role || '管理员',
    // Use the first character of name for the header avatar text.
    avatar: state => String(state.userInfo.name || state.userInfo.username || state.userInfo.login_name || 'A').charAt(0).toUpperCase() || 'A',
  },

  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('admin_token', token)
      localStorage.setItem('token', token)
    },
    SET_USER(state, user) {
      state.userInfo = user
      localStorage.setItem('admin_user', JSON.stringify(user))
      localStorage.setItem('userInfo', JSON.stringify(user))
    },
    CLEAR(state) {
      state.token = ''
      state.userInfo = {}
      localStorage.removeItem('admin_token')
      localStorage.removeItem('token')
      localStorage.removeItem('admin_user')
      localStorage.removeItem('userInfo')
      localStorage.removeItem('qd')
    },
  },

  actions: {
    login({ commit }, payload) {
      return new Promise((resolve, reject) => {
        if (payload && payload.token) {
          commit('SET_TOKEN', payload.token)
          commit('SET_USER', payload)
          resolve()
          return
        }

        if (payload.username === 'admin' && payload.password === '123456') {
          commit('SET_TOKEN', 'demo_token_xxx')
          commit('SET_USER', { username: 'Admin', loginName: 'admin', role: '超级管理员' })
          resolve()
        } else {
          reject(new Error('用户名或密码错误'))
        }
      })
    },
    logout({ commit }) {
      commit('CLEAR')
    },
  },
}
